let district = [
    { "x": -1, "y": -1, "type": "right", "opts": "start", "pickup": false },
    { "x": -2, "y": -1, "type": "right" },
    { "x": -3, "y": -1, "type": "voidright" },
    { "x": -4, "y": -1, "type": "righttop" },
    { "x": -5, "y": -2, "type": "top" },
    { "x": -6, "y": -3, "type": "top" },
    { "x": -7, "y": -4, "type": "top" },
    { "x": -8, "y": -5, "type": "topleft" },
    { "x": -8, "y": -6, "type": "left" },
    { "x": -8, "y": -7, "type": "voidleft" },
    { "x": -8, "y": -8, "type": "voidleft" },
    { "x": -9, "y": -10, "type": "lefttoright" },
    { "x": -10, "y": -10, "type": "right" },
    { "x": -11, "y": -10, "type": "right" },
    { "x": -13, "y": -11, "type": "righttoleft" },
    { "x": -14, "y": -13, "type": "lefttoright" },
    { "x": -16, "y": -14, "type": "righttoleft" },
    { "x": -16, "y": -15, "type": "voidleft" },
    { "x": -16, "y": -16, "type": "left" },
    { "x": -16, "y": -17, "type": "left" },
    { "x": -16, "y": -18, "type": "left" },
    { "x": -16, "y": -19, "type": "voidleft" },
    { "x": -16, "y": -20, "type": "left" },
    { "x": -17, "y": -22, "type": "lefttoright" },
    { "x": -18, "y": -22, "type": "right" },
    { "x": -19, "y": -22, "type": "right" },
    { "x": -20, "y": -22, "type": "righttop" },
    { "x": -21, "y": -23, "type": "top" },
    { "x": -22, "y": -24, "type": "top" },
    { "x": -23, "y": -25, "type": "voidbottop" },
    { "x": -24, "y": -26, "type": "top" },
    { "x": -25, "y": -27, "type": "topleft" },
    { "x": -25, "y": -28, "type": "lefttop" },
    { "x": -26, "y": -29, "type": "topleft" },
    { "x": -26, "y": -30, "type": "left" },
    { "x": -27, "y": -32, "type": "lefttoright" },
    { "x": -28, "y": -32, "type": "voidright" },
    { "x": -29, "y": -32, "type": "right" },
    { "x": -30, "y": -32, "type": "right" },
    { "x": -31, "y": -32, "type": "right", "pickup": false },
    { "x": -32, "y": -32, "type": "right", "opts": "end", "pickup": false }
];

export default district;